module.exports = __webpack_public_path__ + "static/media/conexion.fb5e79f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/conexion.svg
// module id = 160
// module chunks = 0